export default {
  row: {
    display: [`block`, `block`, `flex`],
    flexWrap: `wrap`,
    mb: 3
  },
  column: {
    flex: `auto`,
    mb: [3, 3, 0],
    '+ div': {
      ml: [0, 0, 3]
    },
    maxWidth: '300px'
  },
  submission: {
    flex: `auto`,
    mb: [3, 3, 0],
    '+ div': {
      ml: [0, 0, 3]
    },
    maxWidth: '500px'
  },
  input: {
    border: `omegaLight`,
    bg: `omegaLight`,
    color: `omegaDark`,
    outline: `none`,
    '::placeholder': {
      color: `omegaDark`
    }
  },
  textarea: {
    variant: 'forms.input',
    fontSize: 3,
    minHeight: 100
  },
  label: {
    mb: 2
  },
  submit: {
    display: [`flex`, `flex`, `flex`],
    flexWrap: `wrap`,
    pad: 0
  },
  buttonGroup: {
    display: 'flex',
    direction: 'column',
    mb: 3,
    'justify-content': 'space-between'
  }
}
